define(
	'actions/rsvps',[
	"jquery",
	"underscore",
	"backbone",
	"react",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
	],
	function($,_,Backbone,React,AppDispatcher,Constants){
		return Backbone.Model.extend({
			init: function(params) {
			},
			create: function(params, options) {
				window.api.request("rsvps", null).create({
					title: params.title,
					message: params.message,
					address: params.address,
					starts_at: params.starts_at,
					ends_at: params.ends_at,
					remind_at: params.remind_at,
					allow_comments: params.allow_comments,
					buncee_guid: params.buncee_guid,
					recipients: params.recipients,
					timezone: params.timezone
				}).done(function(response) {
					if(options && typeof options.success == "function") {
						options.success();
					}
				});
			},
			update: function(params, options) {
				window.api.request("rsvps", params.guid).update({
					title: params.title,
					message: params.message,
					address: params.address,
					starts_at: params.starts_at,
					ends_at: params.ends_at,
					remind_at: params.remind_at,
					allow_comments: params.allow_comments,
					buncee_guid: params.buncee_guid,
					recipients: params.recipients,
					timezone: params.timezone,
					notify_existing_recipients: params.notify_existing_recipients
				}).done(function(response) {
					if(options && typeof options.success == "function") {
						options.success(response);
					}
				}).fail(function(response) {
					if(options && typeof options.failure == "function") {
						options.failure(response);
					}
				});
			},
			addRSVPs: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.ADD_RSVP,
					data: params
				});
			},
			dispatchInitComment: function(guid, params) {
				AppDispatcher.dispatch({
					actionType: Constants.INIT_RSVP_COMMENT,
					data: params,
					guid: guid
				});
			},
			dispatchDeleteComment: function(params) {
				AppDispatcher.dispatch({
					actionType: Constants.REMOVE_RSVP_COMMENT,
					data:params
				});
			},
			pull: function(guid) {
				var self = this;
				var rsvps = [];

				if(guid) {
					window.api.request("rsvps", guid).execute().done(function(response) {
						self.addRSVPs(response.data);
					});
				}
				else {
					window.api.request("rsvps").each(function iterator (index, item) {
						rsvps.push(item);
					}, function () {
						self.addRSVPs(rsvps);
					});
				}
			},
			createComment: function(params, options) {
				var self = this;

				window.api.request("rsvps/comment").create(params).done(function(response) {
					self.dispatchInitComment(response.rsvp_guid, response.comment);

					if(options && typeof options.success == "function") {
						options.success(response);
					}
				});
			},
			deleteComment: function(guid, params, options) {
				var self = this;

				window.api.request("rsvps/comment", guid).delete(params).done(function() {
					self.dispatchDeleteComment({guid: params.rsvp_guid});

					if(options && typeof options.success == "function") {
						options.success();
					}
				});
			}
		});
	}
);
